import script from "./MoleculeGradesFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeGradesFilter.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeGradesFilter.vue?vue&type=style&index=0&id=0bf0ab0a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf0ab0a"]])

export default __exports__